import React from 'react';
import { motion } from 'framer-motion';
import type { Article } from '../../types/blog';
import ArticleCard from './ArticleCard';

interface RelatedArticlesProps {
  articles: Article[];
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ articles }) => {
  if (articles.length === 0) return null;

  return (
    <section className="mt-14">
      <h2 className="text-xl md:text-2xl font-bold text-fg mb-6">Articles liés</h2>
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: {},
          show: { transition: { staggerChildren: 0.07 } },
        }}
      >
        {articles.map((article) => (
          <motion.div
            key={article.slug}
            variants={{
              hidden: { opacity: 0, y: 20 },
              show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
            }}
          >
            <ArticleCard article={article} />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default RelatedArticles;
